// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ySof","title":"Header_title__3rbYc","left":"Header_left__2QjpG","clinicName":"Header_clinicName__DT9_U"};